var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2259_26666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60359 8.92088C8.60359 7.06056 10.1173 5.54688 11.9776 5.54688C13.8379 5.54688 15.3521 7.06056 15.3521 8.92088C15.3521 10.7812 13.8385 12.2949 11.9776 12.2949C10.1167 12.2949 8.60359 10.7812 8.60359 8.92088ZM9.16359 8.92088C9.16359 10.4726 10.4258 11.7349 11.9776 11.7349C13.5293 11.7349 14.7921 10.4726 14.7921 8.92088C14.7921 7.36912 13.5299 6.10688 11.9776 6.10688C10.4253 6.10688 9.16359 7.36912 9.16359 8.92088ZM11.9921 13.4009C9.21343 13.4009 6.95215 15.6616 6.95215 18.4409V18.7209C6.95215 18.8754 7.07759 19.0009 7.23215 19.0009C7.38671 19.0009 7.51215 18.8754 7.51215 18.7209V18.4409C7.51215 15.9707 9.52199 13.9609 11.9921 13.9609C14.4623 13.9609 16.4721 15.9707 16.4721 18.4409V18.7209C16.4721 18.8754 16.5976 19.0009 16.7521 19.0009C16.9067 19.0009 17.0321 18.8754 17.0321 18.7209V18.4409C17.0321 15.6616 14.7709 13.4009 11.9921 13.4009Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2259_26666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.08,
    height: 14,
    fill: "white",
    transform: "translate(6.95215 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/MyProfile.0b2a4aa8dad99455c549911069b3e10e.svg";
export { ForwardRef as ReactComponent };